/* this file added by Bearer Web Developer  */
import { useThemeMode } from '../../../../../../states/contexts/theme';
import BearerMapProvider from '../../../../../map/BearerMapApi/BearerMapProvider';
import MapApi from './mapApi';
import styles from './mapBox.module.scss';

const MapBox: React.FC = () => {
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.map_box} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <BearerMapProvider><MapApi /></BearerMapProvider>
        </div>
    )
}
export default MapBox;